import React from 'react'

export default function PublicRelationsDB() {
  return (
    <div>PublicRelationsDB</div>
  )
}
